import React, { useState, useEffect } from "react";
import {
  DELAY_MARKING_RADIO_BTN,
  MY_VACATIONS,
  MY_VACATIONS_RADIO_BTN,
  VIEW_LOGS_MAP,
} from "../Constants";
import Grid from "@material-ui/core/Grid";
import "./viewLog.scss";
import FooterPagination from "../../../common/FooterPagination";
import iconBack from "../../../../assets/Icon_down_outline.svg";
import Funnel from "../../../../assets/funnel.svg";
import MobileFilterWithDatePicker from "../../../common/Modules/MobileFilterWithDatePicker";
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import { getDateByRanges } from "../../../DashboardAppointmentsView/Constant";
import { convertDate, convertToFilterMenuFormat } from "./ViewLogsHelper";

const ViewLogsContainerMobile = ({
  backClick,
  logType,
  tableData,
  totalRecords,
  logFilterData,
  handleViewLogOnFilter,
  selectedRadioBtn,
  handleRadioBtn,
}) => {
  const [headerData, setHeaderData] = useState([]);
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [selected_header_item, setSelectedHeaderItem] = useState(null);
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    dateDisplayFormat: "DD MMM YYYY",
    rangeColors: "#F969A4",
    color: "#F969A4",
    key: "selection",
  });

  const [logs, setLogs] = useState([]);
  const [totalTableDataCount, settotalTableDataCount] = useState(0);
  const [consultationList, setConsultationList] = useState([]);
  const [doctorFilterList, setDoctorFilterList] = useState([]);
  const [actionFilterList, setActionFilterList] = useState([]);
  useEffect(() => {
    let headerData = [...VIEW_LOGS_MAP[logType].HEADERS];
    // headerData.forEach((item) => {
    //   if (item.title === "DATE & TIME") {
    //     item.show_filter = true;
    //     setSelectedHeaderItem(item);
    //   }
    // });
    setHeaderData(headerData);
  }, []);

  useEffect(() => {
    let currentTableData = tableData && tableData[logType];
    setLogs(currentTableData);
    // settotalTableDataCount(tableData?.length);
  }, [tableData]);

  useEffect(() => {
    settotalTableDataCount(totalRecords);
  }, [totalRecords]);

  const handleOpenMobFilter = () => {
    if (!selected_header_item) {
      let headerData = [...VIEW_LOGS_MAP[logType].HEADERS];
      headerData.forEach((item) => {
        if (item.title === "DATE & TIME") {
          item.show_filter = true;
          setSelectedHeaderItem(item);
        }
      });
      setHeaderData(headerData);
    }
    setShowMobileFilter(true);
  };

  const handleCloseMobFilter = () => {
    setShowMobileFilter(false);
  };

  const openMobileMenuList = (val) => {
    headerData.forEach((dh) => {
      dh.show_filter = false;
    });
    let index = headerData.findIndex((list) => list.id === val.id);
    headerData[index].show_filter = true;
    if (val?.title === "CONSULTATION") {
      setConsultationList(headerData[index].menuData);
    }
    if (val?.title === "ACTION") {
      setActionFilterList(headerData[index].menuData);
    }
    if (val?.title === "ROLE NAME") {
      setDoctorFilterList(headerData[index].menuData);
    }
    setHeaderData([...headerData]);
    setSelectedHeaderItem(val);
  };

  const handleMobileSelectedItem = (val) => {
    setSelectedHeaderItem(val);
  };

  const selectMobileFilterOptions = (item) => {
    let val = selected_header_item;
    let index = headerData.findIndex((list) => list.id === val.id);
    let index1 = headerData[index].menuData.indexOf(item);
    headerData[index].menuData.map((data) => (data.selected = false));
    headerData[index].menuData[index1].selected = true;
    setHeaderData([...headerData]);
  };

  const DateTimeRangeRender = () => {
    return (
      <DateRangePicker
        ranges={[selectionRange]}
        startDatePlaceholder="From"
        endDatePlaceholder="To"
        showSelectionPreview={true}
        editableDateInputs={true}
        showPreview={false}
        staticRanges={[]}
        inputRanges={[]}
        dragSelectionEnabled={true}
        onChange={(item) => handleSelect(item.selection)}
        className="range-only-date m-auto"
        maxDate={moment().toDate()}
        minDate={moment().subtract(2, "months").toDate()}
      />
    );
  };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges);
  };

  const handleApplyFilter = () => {
    let obj = {};
    let allSelectedDate = {};
    let selectedValue = headerData;
    selectedValue.forEach((data) => {
      allSelectedDate = getSelectedData(data?.mobileFilterTitle);
      obj = { ...obj, ...allSelectedDate };
    });
    handleCloseMobFilter();
    applyParams({ ...logFilterData, ...obj, page_number: 1 });
  };

  const getSelectedData = (filterName) => {
    let data = headerData;
    let index = data.findIndex(
      (data) => data?.mobileFilterTitle === filterName
    );
    let selectedData = headerData[index]?.menuData.find(
      (val) => val.selected === true
    );
    switch (filterName) {
      case "CONSULTATION":
        return { consultation_filter: selectedData?.name };
      case "ACTION":
        return { action_filter: selectedData?.value };
      case "ROLE":
        return { role_filter: selectedData?.value };
      case "ROLE NAME":
        return { doctor_name_filter: selectedData?.value };
      case "DATE & TIME":
        let range = {};
        let rangeTemp = {};
        if (selectedData?.value !== "Date Range") {
          rangeTemp = getDateByRanges(selectedData?.value);
          range["start_date"] = rangeTemp.startDate;
          range["end_date"] = rangeTemp.endDate;
        } else {
          range = {
            start_date: moment(selectionRange.startDate).format("YYYY-MM-DD"),
            end_date: moment(selectionRange.endDate).format("YYYY-MM-DD"),
          };
        }
        return range;
      default:
        return "";
    }
  };

  const applyParams = (params) => {
    handleViewLogOnFilter(params);
  };

  const handleResetAllFilter = () => {
    handleCloseMobFilter();
    let defaultPayload = {
      start_date: "",
      end_date: "",
      page_number: "1",
      record_per_page: "10",
      doctor_name_filter: "all",
      role_filter: "all",
      consultation_filter: "All",
      action_filter: "all",
    };
    applyParams(defaultPayload);
  };

  const handleFilterSearch = (value) => {
    let index = headerData.findIndex(
      (list) => list.title === selected_header_item.title
    );
    if (headerData[index].title === "CONSULTATION") {
      const filterData = consultationList.filter((data) =>
        data?.name?.toLowerCase().includes(value?.toLowerCase())
      );
      headerData[index].menuData = filterData;
      setHeaderData([...headerData]);
    }
    if (headerData[index].title === "ROLE NAME") {
      const filteredData = doctorFilterList.filter(
        (doc) =>
          doc?.value?.toLowerCase()?.includes(value?.toLowerCase()) ||
          doc?.name?.toLowerCase()?.includes(value?.toLowerCase())
      );
    }
    if (headerData[index].title === "ACTION") {
      const filteredData = actionFilterList.filter(
        (doc) =>
          doc?.value?.toLowerCase()?.includes(value?.toLowerCase()) ||
          doc?.name?.toLowerCase()?.includes(value?.toLowerCase())
      );
      headerData[index].menuData = filteredData;
      setHeaderData([...headerData]);
    }
  };

  const mapTableData = (cell, header) => {
    if (header === "DATE & TIME") {
      return (
        <>
          {convertDate(cell["created_at"])[0]}
          <br />
          <strong> {convertDate(cell["created_at"])[1]}</strong>
        </>
      );
    } else {
      return <>{cell[`${header?.toLowerCase().replaceAll(" ", "_")}`]}</>;
    }
  };

  const createCell = (cell) => {
    let tableheader = headerData;
    if (
      logType === MY_VACATIONS &&
      selectedRadioBtn === MY_VACATIONS_RADIO_BTN
    ) {
      tableheader = tableheader?.filter(
        (data) => data.title !== "CONSULTATION"
      );
    }
    let headers = tableheader?.map((obj) => {
      return obj.title;
    });
    return (
      <Grid container className="py-2" spacing={3}>
        {headers.map((hd) => {
          return (
            <Grid item xs={hd === "ACTION" ? 12 : 6}>
              <div
                style={{ color: "#f969a4", fontWeight: "600" }}
                className="view-logs-container-mobile-cell-table-title"
              >
                {hd}
              </div>
              <div className="view-logs-container-mobile-cell-table-subtitle">
                {mapTableData(cell, hd)}
              </div>
            </Grid>
          );
        })}
      </Grid>
    );
  };
  return (
    <div className="view-logs-container-mobile">
      <div className="py-2 d-flex justify-content-between align-items-center">
        <div
          className="view-logs-container-mobile-logs-title"
          onClick={backClick}
        >
          <span className="mx-2">
            <img
              style={{
                width: "7px",
                height: "12px",
                transform: "rotate(180deg)",
              }}
              src={iconBack}
              alt="Sort"
            />
          </span>
          Logs
        </div>
        <div className="view-logs-container-mobile-filter">
          <img src={Funnel} alt="filters" onClick={handleOpenMobFilter} />
        </div>
      </div>
      {logType === MY_VACATIONS && (
        <div className="d-flex py-4">
          <div
            // className="form-check form-check-inline"
            style={{ width: "150px" }}
          >
            <input
              type="radio"
              value={MY_VACATIONS_RADIO_BTN}
              id="My Vacations"
              name="log"
              checked={selectedRadioBtn === MY_VACATIONS_RADIO_BTN}
              onChange={handleRadioBtn}
            />
            <label htmlFor="My Vacations" className="mb-0 px-2">
              <span>My Vacations</span>
            </label>
          </div>
          <div style={{ width: "150px" }}>
            <input
              type="radio"
              value={DELAY_MARKING_RADIO_BTN}
              id="Delay Marking"
              name="log"
              checked={selectedRadioBtn === DELAY_MARKING_RADIO_BTN}
              onChange={handleRadioBtn}
            />
            <label htmlFor="Delay Marking" className="mb-0 px-2">
              <span>Delay Marking</span>
            </label>
          </div>
        </div>
      )}
      <div className="view-logs-container-mobile-cell">
        {logs?.length > 0 ? (
          logs?.map((obj) => {
            return (
              <div style={{ padding: "3%", borderBottom: "1px solid #ccc" }}>
                {createCell(obj)}
              </div>
            );
          })
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            <h6>No Data Available</h6>
          </div>
        )}
      </div>
      {logs?.length > 0 && (
        <div className="px-4">
          <FooterPagination
            currentPage={logFilterData?.page_number}
            totalCount={totalTableDataCount || 100}
            pageSize={10} //{logs?.length > 0 && logs.length}
            onPageChange={(number) => {
              applyParams({ ...logFilterData, page_number: number });
            }}
          />
        </div>
      )}
      <MobileFilterWithDatePicker
        showMobileFilter={showMobileFilter}
        menuList={headerData}
        selectedMenu={selected_header_item}
        handleClose={handleCloseMobFilter}
        openMobileMenuList={openMobileMenuList}
        handleMobileSelectedItem={handleMobileSelectedItem}
        selectMobileFilterOptions={selectMobileFilterOptions}
        handleApplyFilter={handleApplyFilter}
        handleResetAllFilter={handleResetAllFilter}
        handleFilterSearch={handleFilterSearch}
        DateTimeRangeRender={DateTimeRangeRender}
        placeholderForSearch={`Search ${
          selected_header_item?.title === "CONSULTATION"
            ? "for procedure"
            : selected_header_item?.title === "ACTION"
            ? "for field"
            : selected_header_item?.title === "ROLE NAME"
            ? "person"
            : ""
        }`}
      />
    </div>
  );
};
export default ViewLogsContainerMobile;
